import { Directive, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { BezugsrechtService } from '@zero/bezugsrecht/domain';
import { AbstractUserMessagesHolderService } from '@zero/shared/util-abstract-services';
import { BezugsrechtData, CorporateActionType } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';
import { Subscription } from 'rxjs';

@Directive()
export class WahldividendeBase implements OnInit, OnDestroy {
  public model?: BezugsrechtData;
  public rootUrl?: string;

  public readonly commonRoutes = commonRoutes;
  protected _subscriptions: Subscription[] = [];

  protected service = inject(BezugsrechtService);
  protected router = inject(Router);
  protected msgService = inject(AbstractUserMessagesHolderService);
  protected translateService = inject(TranslocoService);

  public ngOnInit(): void {
    this.rootUrl = `${commonRoutes.postlogin.wahldividende}/${this.service.isin}`;
    this._subscriptions.push(
      this.service.bezugsrechtData$.subscribe((data) => {
        if (
          !data ||
          this.service.redirectInvalidData([CorporateActionType.WDIV, CorporateActionType.WDIF], this.router, data.asset, data.announcement)
        ) {
          return;
        }

        this.model = data;
      }),
    );
  }

  public ngOnDestroy(): void {
    if (this._subscriptions?.length) {
      this._subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
  }
}
